export interface GetDriverListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDriverListPagingAndFilterResponseData
}

export interface GetDriverListPagingAndFilterResponseData {
    items: GetDriverListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetDriverListPagingAndFilterResponseItem {
    driverId: string
    nameSurname: string
    tckn: string
    name: string
    surname: string
    relatedCompanyId: string
    relatedCompanyName: string
    phone1: string
    phone2?: string
    email?: string
    workStartDate?: string
    workEndDate?: string
    workStartDateStr?: string
    workEndDateStr?: string
    address?: string
    description?: string
    isCustomActive: boolean
    driverImage: string
    licenceSerialNumber?: string
    driverRecordNo?: string
    bloodTypeId?: string
    bloodTypeName?: string
    dateOfBirth?: string
    givenDate?: string
    validityDate?: string
    givenPlace?: string
    licenceImage?: string
    driverClasses: GetDriverListPagingAndFilterResponseDriverClass[]
    identitySerialNumber?: string
    citizenshipId?: string
    citizenshipName?: string
    identityValidityDate?: string
    age?: number
    genderId?: string
    genderName?: string
    periodicalDocuments: GetDriverListPagingAndFilterResponsePeriodicalDocument[]
    fileArchives: GetDriverListPagingAndFilterResponseFileArc[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetDriverListPagingAndFilterResponseDriverClass {
    label: string
    value: string
}

export interface GetDriverListPagingAndFilterResponsePeriodicalDocument {
    periodicalDocumentId: string
    documentTypeId: string
    documentTypeName: string
    documentNo: string
    startDate: string
    endDate: string
    additionalValue1: string
    additionalValue1Name: any
    dateControl: boolean
    isInUse: boolean
    availableDays: number
}

export interface GetDriverListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetDriverListPagingAndFilterResponseData: GetDriverListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}